import { gql } from "@apollo/client";

export const GET_USER_AUDITS = gql`
    query GetUserAudits {
        ums_audits(where: { event: { _eq: 2000 } }, order_by: { timestamp: desc }, limit: 2) {
            timestamp
        }
    }
`;
